export const TO_DO_TASK_STATUS = "to_do";
export const ARCHIVED_TASK_STATUS = "archived";
export const COMPLETED_TASK_STATUS = "completed";
export const READY_TO_SUBMIT_TASK_STATUS = "ready_to_submit";
export const OVERDUE_TASK_STATUS = "overdue";
export const DUE_SOON_TASK_STATUS = "due_soon";

export const TASK_STATUS = {
  [TO_DO_TASK_STATUS]: TO_DO_TASK_STATUS,
  [ARCHIVED_TASK_STATUS]: ARCHIVED_TASK_STATUS,
  [COMPLETED_TASK_STATUS]: COMPLETED_TASK_STATUS,
  [OVERDUE_TASK_STATUS]: OVERDUE_TASK_STATUS,
  [DUE_SOON_TASK_STATUS]: DUE_SOON_TASK_STATUS,
};

export const TO_DO_TASK_STATUS_LABEL = "To do";
export const ARCHIVED_TASK_STATUS_LABEL = "Archived";
export const COMPLETED_TASK_STATUS_LABEL = "Completed";
export const OVERDUE_TASK_STATUS_LABEL = "Overdue";
export const DUE_SOON_TASK_STATUS_LABEL = "Due soon";

export const TASK_STATUS_LABELS = {
  [TO_DO_TASK_STATUS]: TO_DO_TASK_STATUS_LABEL,
  [ARCHIVED_TASK_STATUS]: ARCHIVED_TASK_STATUS_LABEL,
  [COMPLETED_TASK_STATUS]: COMPLETED_TASK_STATUS_LABEL,
  [OVERDUE_TASK_STATUS]: OVERDUE_TASK_STATUS_LABEL,
  [DUE_SOON_TASK_STATUS]: DUE_SOON_TASK_STATUS_LABEL,
};

export const TASK_PRIORITY_LOW = "low";
export const TASK_PRIORITY_MEDIUM = "medium";
export const TASK_PRIORITY_HIGH = "high";

export const ONBOARD_SPONSORED_EMPLOYEE_TASK_TYPE = "onboard_sponsored_employee";
export const REPORT_EMPLOYEES_NUMBER_CHANGE_TASK_TYPE = "report_employees_number_change";
export const SUBMIT_FOR_REVIEW_TASK_TYPE = "submit_for_review";
export const ONBOARD_CANDIDATE_ASSESSMENT_TASK_TYPE = "onboard_candidate_assessment";
export const DOCUMENT_TASK_TYPE = "document";
export const FLOW_TASK_TYPE = "flow";
export const GUIDE_TASK_TYPE = "guide";
export const GUIDE_WITH_CUSTOM_BUTTON_TASK_TYPE = "guide_with_custom_button";
export const INFO_TASK_TYPE = "info";
export const RIGHT_TO_WORK_CHECK_EMPLOYEE = "right_to_work_check_employee";
export const RIGHT_TO_WORK_CHECK_EMPLOYER = "right_to_work_check_employer";

export const MY_TASKS_TAB = "my_tasks";
export const MY_TASKS_NAME = "My tasks";

// Employer role tasks tabs;
export const EMPLOYEES_TASKS_TAB = "employees_tasks";

export const EMPLOYEES_TASKS_NAME = "Employees' tasks";
export const EMPLOYER_EMPLOYEES_TASKS_NAME = "Employee's tasks";

export const EMPLOYER_TASKS_TABS = {
  [MY_TASKS_TAB]: MY_TASKS_NAME,
  [EMPLOYEES_TASKS_TAB]: EMPLOYEES_TASKS_NAME,
};

export const EMPLOYER_TABS = [MY_TASKS_TAB, EMPLOYEES_TASKS_TAB];

// Employer Employees
export const EMPLOYER_EMPLOYEES_TASKS_TABS = {
  [MY_TASKS_TAB]: MY_TASKS_NAME,
  [EMPLOYEES_TASKS_TAB]: EMPLOYER_EMPLOYEES_TASKS_NAME,
};

// Expert role tasks tabs

export const EMPLOYER_TASKS_TAB = "employer_tasks";
export const CANDIDATE_TASKS_TAB = "candidate_tasks";
export const TASKS_TAB = "tasks";

export const EMPLOYER_TASKS_NAME = "Employer's tasks";
export const CANDIDATE_TASKS_NAME = "Candidate's tasks";
export const EMPLOYEE_TASKS_NAME = "Employee's tasks";

export const EXPERT_TASKS_TABS = {
  [EMPLOYER_TASKS_TAB]: EMPLOYER_TASKS_NAME,
  [CANDIDATE_TASKS_TAB]: CANDIDATE_TASKS_NAME,
};

export const EXPERT_TABS = [EMPLOYER_TASKS_TAB, CANDIDATE_TASKS_TAB];

export const EXPERT_EMPLOYERS_AND_EMPLOYEES_TASK_TABS = {
  [EMPLOYER_TASKS_TAB]: EMPLOYER_TASKS_NAME,
  [EMPLOYEES_TASKS_TAB]: EMPLOYEE_TASKS_NAME,
};

export const EXPERT_EMPLOYERS_AND_EMPLOYEES_TABS = [EMPLOYER_TASKS_TAB, EMPLOYEES_TASKS_TAB];

export const TASK_TABS_NAME_EMPLOYER = {
  [EMPLOYER_TASKS_TAB]: EMPLOYER_TASKS_NAME,
  [CANDIDATE_TASKS_TAB]: CANDIDATE_TASKS_NAME,
};

export const TASK_TABS_SERVICE_EMPLOYER = [EMPLOYER_TASKS_TAB, CANDIDATE_TASKS_TAB];

// Candidate role tasks tabs

export const TASK_TABS_NAME_CANDIDATE = {
  [MY_TASKS_TAB]: MY_TASKS_NAME,
  [EMPLOYER_TASKS_TAB]: EMPLOYER_TASKS_NAME,
};

export const TASK_TABS_SERVICE_CANDIDATE = [MY_TASKS_TAB, EMPLOYER_TASKS_TAB];

export const TASK_TABS_EMPLOYEE = [EMPLOYER_TASKS_TAB, TASKS_TAB];

export const TASK_TABS_NAME_EMPLOYEE = {
  [EMPLOYER_TASKS_TAB]: EMPLOYER_TASKS_NAME,
  [TASKS_TAB]: EMPLOYEE_TASKS_NAME,
};

// Employee role tasks tabs
export const EMPLOYERS_TASKS_TAB = "employers_tasks";

export const EMPLOYERS_TASKS_NAME = "Employer's tasks";

export const EMPLOYEE_TASKS_TABS = {
  [MY_TASKS_TAB]: EMPLOYEES_TASKS_NAME,
  [EMPLOYERS_TASKS_TAB]: EMPLOYERS_TASKS_NAME,
};

export const EMPLOYEE_TABS = [MY_TASKS_TAB, EMPLOYERS_TASKS_TAB];

export const STATUS_TASKS_TABLE_COLUMN_KEY = "status";

export const INACTIVE_TASKS_TABLE_ROW_TYPE = "inactive";
export const WARNING_TASKS_TABLE_ROW_TYPE = "warning";
